import { render, staticRenderFns } from "./PageSignInFailed.vue?vue&type=template&id=31fcd520&"
import script from "./PageSignInFailed.vue?vue&type=script&lang=js&"
export * from "./PageSignInFailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports